import { cn } from "@/lib/utils";
import TimelineIcon from "./TimelineIcon";
interface TimelineSectionHeaderTitleBlockProps {
  icon: string;
  name: string;
  description: string;
  cosmicAspect?: string;
  align: "left" | "right";
}
const TimelineSectionHeaderTitleBlock = ({
  icon,
  name,
  description,
  cosmicAspect,
  align
}: TimelineSectionHeaderTitleBlockProps) => {
  return <div className={cn("flex flex-col gap-0 max-w-sm", align === "right" ? "text-right items-end pr-8" : "text-left items-start pl-8")}>
      {/* Icon positioned above title */}
      <div className="mb-2">
        <TimelineIcon iconName={icon} size={100} />
      </div>
      
      {/* Title */}
      <h3 className="font-bold text-uplivion-blue leading-4 text-sm mb-2">{name}</h3>
      
      <p className="text-gray-600 text-sm leading-relaxed">
        {description}
      </p>
      
      {cosmicAspect && <p className="text-uplivion-blue text-xs font-medium italic">
          {cosmicAspect}
        </p>}
    </div>;
};
export default TimelineSectionHeaderTitleBlock;